/* eslint-disable no-debugger */
import axios from 'axios';
// import Vue from 'vue';
import store from '../store';

const CancelToken = axios.CancelToken;
const AxiosTokenSource = CancelToken.source();

const BASE_API_URL = process.env.VUE_APP_API_URI || 'https://api.dev.ofinansdev.com/v2/';
const Services = axios.create({ baseURL: String(BASE_API_URL), cancelToken: AxiosTokenSource.token });

let lang = sessionStorage.getItem('lang') || 'en';

Services.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('userToken');
    if(token) {
      config.headers.common['Authorization'] = `Bearer ${token}`;
    }
    config.headers.common['X-Localization'] = lang;
    return config;
  },
  (error) => Promise.reject(...error)
);

Services.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      AxiosTokenSource.cancel('401 error');
      store.commit('customer/SET_LOGOUT');
    }
    if ([404, 405, 500].includes(error?.response?.status)) {
      let errorMessage = 'An unexpected error occurred. Please try again later.';
      if (lang == 'tr') {
        errorMessage = 'Beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.';
      } else if (lang == 'nl') {
        errorMessage = 'Er is een onverwachte fout opgetreden. Probeer het later opnieuw.';
      } else if (lang == 'de') {
        errorMessage = 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.';
      } else if (lang == 'me') {
        errorMessage = 'Došlo je do neočekivane pogreške. Molimo pokušajte ponovo kasnije.';
      } else if (lang == 'et') {
        errorMessage = 'Ilmnes ootamatu viga. Palun proovi hiljem uuesti.';
      } else if (lang == 'fr') {
        errorMessage = 'Une erreur inattendue est apparue. Veuillez réessayer plus tard.';
      }

      // Vue.$toast.error(errorMessage);
      throw {
        ...error,
        response: {
          ...error.response,
          data: {
            ...error.response.data,
            message: errorMessage
          }
        }
      };
    }
    throw error;
  }
);
export default Services;
